import ButtonIconT from '@components/tailwind-components/Button/ButtonIconT';
import { MAX_PERSISTENT_MENU_ITEMS_COUNT } from '@conversed/shared/src/central/constants/boundaries';
import type React from 'react';
import { type Control, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { TFacebookSettings } from '../../../../../interfaces/TFacebook';
import AddButton from '../../../../common/AddButton';
import FacebookPersistentMenuItem from './FacebookPersistentMenuItem';

interface Props {
  control: Control<TFacebookSettings>;
}

export const FacebookPersistentMenuList: React.FC<Props> = ({ control }) => {
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'persistentMenuList',
  });

  return (
    <>
      {fields.map((field, id) => (
        <div key={field.id}>
          <FacebookPersistentMenuItem
            name={`persistentMenuList.${id}.`}
            control={control}
          />
          {fields.length > 1 && (
            <ButtonIconT
              icon='delete'
              onClick={() => remove(id)}
              label={t('settings.facebook.persistent-menu.delete-locale')}
              color='danger'
            />
          )}
        </div>
      ))}
      {fields.length < MAX_PERSISTENT_MENU_ITEMS_COUNT && (
        <div
          className='flex flex-col items-center gap-3 my-5 cursor-pointer'
          onClick={() =>
            append({ actions: [], inputDisabled: false, locale: '' })
          }>
          <AddButton />
          <p>{t('settings.facebook.persistent-menu.add-new')}</p>
        </div>
      )}
    </>
  );
};

export default FacebookPersistentMenuList;
